(function ($) {
    jQuery(document).ready(function () {
      $( "details.mega-menu summary.list-menu__item" ).hover(
        function() {
          $( this ).parent('details.mega-menu').attr('open', 'open');
          $(this).attr('aria-expanded', 'true');
        }, function() {
          $( this ).parent('details.mega-menu').removeAttr('open');
          $(this).attr('aria-expanded', 'false');
        }
      );
      $( "details.mega-menu .mega-menu__content" ).hover(
        function() {
          $( this ).parents('details.mega-menu').attr('open', 'open');
          $(this).parents('details.mega-menu').find('summary.list-menu__item').attr('aria-expanded', 'true');
        }, function() {
          $( this ).parents('details.mega-menu').removeAttr('open');
          $(this).parents('details.mega-menu').find('summary.list-menu__item').attr('aria-expanded', 'false');
        }
      );
      $('details.mega-menu summary.list-menu__item').click(function(){
        var currentUrl = $(this).attr('handle');
        if(currentUrl != '#') {
          window.location.href= currentUrl;
        }
      });

      // Product detail to click contact link
      $('.product-contact-link a').click(function() {
        var productUrl = window.location.href;
        localStorage.setItem('productUrl', productUrl);
      })
      if($('.field.field-product-url').length > 0) {
        if(localStorage.getItem('productUrl').length>0) {
          $('.field.field-product-url input.field__input').attr('type','text');
          $('.field.field-product-url input.field__input').val(localStorage.getItem('productUrl'));
        }
      }

      // Product COLLAPSABLE DROPDOWN       
      $('.product__description-label').click(function() {
        $(this).parent('.product__description-item').toggleClass('active');
        $(this).parent('.product__description-item').siblings('.product__description-item').removeClass('active');
        $(this).next('.product__description-content').slideToggle();
      })
    });
})(jQuery);